module.exports = __webpack_public_path__ + "static/media/image-feedback.f47de286.png";